__turbopack_context__.v({
  "className": "raleway_664e7850-module__bqkqkW__className",
  "variable": "raleway_664e7850-module__bqkqkW__variable",
});
